import { render } from "./OurServicesMainPageBigScreen.vue?vue&type=template&id=21a31d64"
import script from "./OurServicesMainPageBigScreen.vue?vue&type=script&lang=js"
export * from "./OurServicesMainPageBigScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__